import React from 'react';
import { iconStyle } from './styles';

export const Badge: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={iconStyle(size)}>
      <svg
        width="113px"
        height="113px"
        viewBox="0 0 113 113"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g transform="translate(-664.000000, -757.000000)">
            <g transform="translate(535.000000, 632.000000)">
              <g transform="translate(120.000000, 116.000000)">
                <g transform="translate(9.000000, 9.000000)">
                  <circle
                    fill="#09798D"
                    cx="56.5"
                    cy="56.5"
                    r="56.5"
                  ></circle>
                  <g
                    transform="translate(20.000000, 22.000000)"
                    stroke="#FFFFFF"
                  >
                    <g
                      fillRule="evenodd"
                      transform="translate(15.235294, 4.242424)"
                    >
                      <path
                        d="M30.025236,36.5456778 L30.025236,61.4452618 L21.7441398,56.3426144 C21.3917527,56.1329453 20.9806345,56.1329453 20.6282474,56.3426144 L12.4058824,61.5151515 L12.4058824,36.6155675 M38.6185063,23.4353092 C38.4529433,23.7463974 38.3697838,24.0581958 38.3697838,24.369284 L38.7009098,29.1187055 L34.1437703,31.2984535 C33.8118884,31.4547078 33.5631659,31.6883791 33.397603,31.9994672 L31.0766975,36.2815462 L26.0221131,35.9697478 C25.6902312,35.9697478 25.2759458,36.047875 25.0272234,36.2041293 L20.7180503,38.8512198 L16.4912808,36.2041293 C16.2433143,36.047875 15.9114324,35.9697478 15.5803065,35.9697478 L10.4418066,36.2815462 L8.12165717,31.9994672 C7.9560942,31.6883791 7.70737176,31.4547078 7.37548984,31.2984535 L2.81835036,29.1187055 L3.14947629,24.2918671 C3.14947629,23.9800686 3.06631681,23.5908533 2.90075384,23.357182 L0,19.4643184 L2.81835036,15.4940378 C2.98391332,15.1822393 3.14947629,14.8711512 3.06631681,14.5593527 L2.73519088,9.80993122 L7.29308635,7.63018326 C7.62421228,7.47463917 7.87293472,7.24096791 8.03849769,6.92987974 L10.3594032,2.64709048 L15.4147435,2.9588889 C15.7458694,2.9588889 16.1601549,2.88147198 16.4088773,2.72521764 L20.7180503,0 L24.9448199,2.64709048 C25.2759458,2.80334481 25.6078277,2.9588889 25.9389537,2.88147198 L30.994294,2.56967356 L33.3144435,6.85175257 C33.4807624,7.16284075 33.7287289,7.396512 34.0606108,7.55276634 L38.6185063,9.7325143 L38.2873804,14.4819358 C38.2873804,14.793024 38.3697838,15.1822393 38.5353468,15.4159106 L41.3529412,19.3869014 L38.6185063,23.4353092 Z"
                        id="Stroke-1"
                      ></path>
                    </g>
                    <ellipse
                      cx="35.9117647"
                      cy="24.3939394"
                      rx="9.79411765"
                      ry="9.54545455"
                    ></ellipse>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
